export const noNoWords = ['fuck', 'fucking', 'cunt', 'nigger', 'n$gger', 'jew', 'asshole', 'faggot', 'suck my'];